import { useCreateRecruitmentContext } from '../../Create/Contexts/CreateRecruitmentContext';
import StepProps from '../StepProps';
import JobDetailsStep from './JobDetailsStep';
import { useCompanyContext } from '@/Context/CompanyContext';
import ProcessingState from '@/Models/ProcessingState';

const CreateJobDetailsStep = ({ activeStep, handleNext, handleBack }: StepProps) => {
    const { client, jobDetails, updateJobDetails, setProcessingState, currencies, processingState } =
        useCreateRecruitmentContext();
    const { currentCompanyProfile } = useCompanyContext();
    const { companyName } = currentCompanyProfile;

    const onNextPage = () => {
        // will be used for job ad generation
        setProcessingState(ProcessingState.Idle);
        handleNext?.();
    };

    return (
        <JobDetailsStep
            activeStep={activeStep}
            handleNext={onNextPage}
            handleBack={handleBack}
            jobDetails={jobDetails}
            client={client}
            companyName={companyName}
            updateJobDetails={updateJobDetails}
            currencies={currencies}
            processingState={processingState}
        />
    );
};

export default CreateJobDetailsStep;
